import { useIntl } from 'react-intl';

import { DAY_OF_WEEK_TRANSLATIONS, EVENT_TYPE_TRANSLATIONS } from '../constants';
import type { PassEvent } from '../types';
import { Event } from '../types';

export type FormatDateProps = Omit<PassEvent, 'infoUrl'>;

const useFormatEventDate = ({ startDate, endDate, eventType }: FormatDateProps) => {
  const { formatDate, formatMessage } = useIntl();
  const formattedStart = formatDate(startDate, { month: 'short', day: 'numeric' });
  const formattedEnd = formatDate(endDate, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
  const formattedDate = `${formattedStart} - ${formattedEnd}`;

  if (Event.Festival === eventType || Event.Series === eventType) {
    return `${EVENT_TYPE_TRANSLATIONS[eventType]}: ${formattedDate}`;
  } else if (Event.Recurring === eventType && startDate === endDate) {
    const dayTranslation = DAY_OF_WEEK_TRANSLATIONS[new Date(startDate).getDay()];

    return `${EVENT_TYPE_TRANSLATIONS[eventType]} ${formatMessage(dayTranslation)}`;
  }

  return formattedDate;
};

export default useFormatEventDate;
